
















































































import Vue from 'vue'
import CShimmer from '~/components/shared/configurable/shimmer/CShimmer.vue'
export default Vue.extend({
  components: { CShimmer },
  props: {
    repeat: {
      type: Number,
      default: 3
    },
    showAvatar: { type: Boolean, default: true },
    looklike: {
      type: String,
      required: false,
      default() {
        return null
      }
    }
  }
})
